const BASE64_KEY = "Ehdf/Q+qYtUOgKO9TFGfc+PuRgg76ZPnnEyiu64e6KQ=";

let cachedKey = null;

async function getKey() {
  if (cachedKey) return cachedKey;

  const rawKey = base64ToBytes(BASE64_KEY);
  if (rawKey.length !== 32) {
    throw new Error(`Encryption key must decode to 32 bytes (256-bit AES). Got ${rawKey.length}.`);
  }

  cachedKey = await window.crypto.subtle.importKey(
    "raw",
    rawKey,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  return cachedKey;
}

function base64ToBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function bytesToHex(bytes) {
  return Array.from(bytes).map((b) => b.toString(16)?.padStart(2, "0"))?.join("")?.toUpperCase();
}

export async function encryptPayload(plainText) {
  const key = await getKey();
  const plaintextBytes = new TextEncoder().encode(plainText);

  // Fresh 12-byte nonce every call — never reuse this with the same key.
  const nonce = window.crypto.getRandomValues(new Uint8Array(12));

  // Web Crypto's AES-GCM appends the 16-byte auth tag to the ciphertext automatically,
  // so cipherBuffer is already [ciphertext|tag].
  const cipherBuffer = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv: nonce },
    key,
    plaintextBytes
  );

  const combined = new Uint8Array(nonce.length + cipherBuffer.byteLength);
  combined.set(nonce, 0);
  combined.set(new Uint8Array(cipherBuffer), nonce.length);

  return bytesToHex(combined);
}
